export default "__VITE_ASSET__BvXBYoVj__"